import { useLanguage } from "../../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      className="marquee-paused relative overflow-hidden border-y border-white/10 bg-kn-navy2 py-5"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-mono text-[11px] tracking-[0.32em] uppercase text-white/50">
                  {item}
                </span>
                <span className="h-1 w-1 rounded-full bg-kn-cyan/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
